import { styled } from 'styled-components'
import { Drawer as MuiDrawer, Dialog as MuiDialog } from '@mui/material'
import { onMediumScreen } from 'mixtiles-web-common'
import Button from 'mixtiles-web-common/ui/Button'

export const BottomDrawer = styled(MuiDrawer)`
  &.MuiDrawer-root {
    z-index: 1600 !important;
  }

  .MuiDrawer-paper {
    display: flex;
    justify-content: center;
    border-radius: 16px 16px 0 0;
    padding: 40px 0 40px;
    max-height: 100%;
  }
`

export const Dialog = styled(MuiDialog)`
  .MuiDialog-paper {
    border-radius: 16px;
    padding: 54px 0 52px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 380px;

  ${onMediumScreen()} {
    width: 380px;
  }
`

export const Icon = styled.img`
  width: 134px;
  height: 104px;
  margin-bottom: 24px;
`

export const Title = styled.div`
  font-size: 24px;
  line-height: 120%;
  font-weight: 700;
  max-width: 302px;
  overflow-wrap: break-word;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
`

export const Address = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 140%;
  max-width: 270px;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  margin-top: 12px;
  white-space: pre-line;
`

export const ActionButton = styled(Button)`
  min-width: 229px;
  min-height: 50px;
  margin-top: 28px;

  ${onMediumScreen()} {
    min-width: 220px;
    min-height: 52px;
    margin-top: 36px;
  }
`

export const SecondaryAction = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  line-height: 130%;
  color: ${({ theme }) => theme.colors.black};
  text-decoration: underline;
  margin-top: 16px;
  padding: 8px;
`
